module.exports = __webpack_public_path__ + "372fd5281a8ab0058cf130854e43cb3e.pdf";